// int between min (included) and max (excluded)
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

// in guest.js
export function gimme_range(low, high) {
  let slots = high - low + 1;
  let arr = [];
  while (slots--) {
    arr[slots] = high--;
  }
  return arr;
}

export function disableScroll() {
  // disable Mui scrollLock but prevent scrolling since this element wont scroll with page
  const htmlEl = document.querySelector("html");
  const st = document.documentElement.scrollTop;
  htmlEl.style.top = `${-st}px`;
  htmlEl.classList.add("ovrflw");
}
export function enableScroll() {
  const htmlEl = document.querySelector("html");
  const st = Math.abs(parseInt(htmlEl.style.top));
  htmlEl.classList.remove("ovrflw");
  // do this after remove position
  // htmlEl.scrollTop = st;
  document.documentElement.scrollTop = st;
}
